import { render, staticRenderFns } from "./wait-case-chart.vue?vue&type=template&id=46b7dc03&scoped=true"
import script from "./wait-case-chart.vue?vue&type=script&lang=ts"
export * from "./wait-case-chart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b7dc03",
  null
  
)

export default component.exports